import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../pages/Guest/Login";
import ForgotPassword from "../pages/Guest/ForgotPassword";
import ResetPassword from "../pages/Guest/ResetPassword";

const GuestRoutes = () => {
  const admin = useSelector((state) => state.admin.txtconnect_ng_admin);
  const token = useSelector((state) => state.admin.token);

  if (admin && token) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
};

export default GuestRoutes;
